import React, { useEffect, useState } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import packageJson from "../../../package.json";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import StoreIcon from "@mui/icons-material/Store";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsSystemDaydreamOutlinedIcon from "@mui/icons-material/SettingsSystemDaydreamOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import PaymentsIcon from "@mui/icons-material/Payments";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo/root-logo.png";
import "./sidebar.scss";

const Sidebar = () => {
  const [isActive, setIsActive] = useState(
    JSON.parse(localStorage.getItem("navOpen")) === true
      ? JSON.parse(localStorage.getItem("navOpen"))
      : false
  );
  const [accordian, setAccordian] = useState(
    JSON.parse(localStorage.getItem("navOpen2")) === true
      ? JSON.parse(localStorage.getItem("navOpen2"))
      : false
  );
  const [collapsed, setCollapsed] = useState(
    JSON.parse(localStorage.getItem("navOpen3")) === true
      ? JSON.parse(localStorage.getItem("navOpen3"))
      : false
  );
  const [drawer, setDrawer] = useState(
    JSON.parse(localStorage.getItem("navOpen4")) === true
      ? JSON.parse(localStorage.getItem("navOpen4"))
      : false
  );
  const [userMngt, setUserMngt] = useState(
    JSON.parse(localStorage.getItem("navOpen5")) === true
      ? JSON.parse(localStorage.getItem("navOpen5"))
      : false
  );
  const [faq, setFaq] = useState(
    JSON.parse(localStorage.getItem("navOpen6")) === true
      ? JSON.parse(localStorage.getItem("navOpen6"))
      : false
  );
  const [job, setJob] = useState(
    JSON.parse(localStorage.getItem("navOpen7")) === true
      ? JSON.parse(localStorage.getItem("navOpen7"))
      : false
  );

  const adminLogin = useSelector((state) => state.adminLogin);
  const { user } = adminLogin;
  useEffect(() => { }, [user]);
  const navigate = useNavigate();

  const logoutHandler = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("admin");
    localStorage.removeItem("navOpen");
    localStorage.removeItem("navOpen2");
    localStorage.removeItem("navOpen3");
    localStorage.removeItem("navOpen4");
    localStorage.removeItem("navOpen5");
    localStorage.removeItem("navOpen6");
    localStorage.removeItem("navOpen7");
    navigate("/login");
  };

  let activeStyle = {
    color: "#15987a",
  };

  return (
    <div className="sidebar darkmode">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">Roots Funding </span>
          <span className="appversion">V: 2.47</span>
        </Link>
      </div>
      {/* <p className="app-version">V:{packageJson.version}</p> */}
      <hr />
      <div className="center">
        <ul className="menu">
          <p className="title"></p>

          <li>
            <NavLink
              to="/"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </NavLink>
          </li>

          <p className="title"></p>

          <li
            onClick={() => {
              localStorage.setItem("navOpen", !isActive);
              setIsActive(!isActive);
            }}
          >
            <StoreIcon className="icon" />
            <span>Campaign</span>
            <div className="dropdown-icon">
              {isActive ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </li>
          {!isActive && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/create-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Create Campaign
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/initial-approve"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Initial Approval
                </NavLink>
              </li>
              

              <li>
                <NavLink
                  to="/active-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Active
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/rejected-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Rejected
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/for-review-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  For Review
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/deleted-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Deleted
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/completed-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Completed
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paused-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Paused campaigns
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/coming-soon-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Upcoming Campaigns
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/closed-campaign"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Closed Campaigns
                </NavLink>
              </li>
            </ul>
          )}

          <p className="title"></p>

          <li
            onClick={() => {
              localStorage.setItem("navOpen5", !userMngt);
              setUserMngt(!userMngt);
            }}
          >
            {/* <NavLink
              to="/users"
              style={{ textDecoration: "none" }}
              className="main-menu"
            > */}
            <GroupsIcon className="icon" />
            <span>Users Management</span>
            <div className="dropdown-icon">
              {userMngt ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
            {/* </NavLink> */}
          </li>

          {!userMngt && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/users"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Users
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/manage-role"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Manage System Role
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/manage-designation"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Manage Designations
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/commission"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Manage Commissions
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/designation-report"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Designation Report
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/manage-permissions"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Manage Permissions
                </NavLink>
              </li>
            </ul>
          )}

          <p className="title"></p>

          <li>
            <NavLink
              to="/accredited-investors"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <GroupAddIcon className="icon" />
              <span>Accredited Investors</span>
            </NavLink>
          </li>
          <p className="title"></p>
          <li>
            <NavLink
              to="/currency-management"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <PaymentsIcon className="icon" />
              <span>Currency Management</span>
            </NavLink>
          </li>

          <p className="title"></p>
          <li>
            <NavLink
              to="/inventme"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <InventoryOutlinedIcon className="icon" />
              <span>InventMe Management</span>
            </NavLink>
          </li>

          <p className="title"></p>
          <li>
            <NavLink
              to="/news"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <InventoryOutlinedIcon className="icon" />
              <span>News</span>
            </NavLink>
          </li>

          <p className="title"></p>
          <li
            onClick={() => {
              localStorage.setItem("navOpen7", !job);
              setJob(!job);
            }}
          >
            <WorkOutlineOutlinedIcon className="icon" />
            <span>Jobs Management</span>
            <div className="dropdown-icon">
              {job ? <ExpandMoreOutlinedIcon /> : <ExpandLessOutlinedIcon />}
            </div>
          </li>
          {!job && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/career"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Job Listing
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/jobs"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Job Applications
                </NavLink>
              </li>
            </ul>
          )}

          <p className="title"></p>
          <li
            onClick={() => {
              localStorage.setItem("navOpen3", !collapsed);
              setCollapsed(!collapsed);
            }}
          >
            <AttachMoneyOutlinedIcon className="icon" />
            <span>Funds Managament</span>
            <div className="dropdown-icon">
              {collapsed ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </li>
          {!collapsed && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/investment"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Investment
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/transaction"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Transaction
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/suitability-overview"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                 Suitability Overview
                </NavLink>
              </li>
            </ul>
          )}

          <p className="title"></p>
          <li
            onClick={() => {
              localStorage.setItem("navOpen6", !faq);
              setFaq(!faq);
            }}
          >
            <QuizOutlinedIcon className="icon" />
            <span>FAQ's</span>
            <div className="dropdown-icon">
              {faq ? <ExpandMoreOutlinedIcon /> : <ExpandLessOutlinedIcon />}
            </div>
          </li>
          {!faq && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/offeror-faq"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Offeror
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/investor-faq"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Investor
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/accredited-faq"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Accredited
                </NavLink>
              </li>
            </ul>
          )}

          <p className="title"></p>
          <li
            onClick={() => {
              localStorage.setItem("navOpen2", !accordian);
              setAccordian(!accordian);
            }}
          >
            <PsychologyOutlinedIcon className="icon" />
            <span>Pages</span>
            <div className="dropdown-icon">
              {accordian ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </li>
          {!accordian && (
            <ul className="sub-list">
              <li>
                <NavLink to="/pages" className="sub-menu">
                  Page List
                </NavLink>
              </li>
              <li>
                <NavLink to="/categories" className="sub-menu">
                  Categories
                </NavLink>
              </li>
              <li>
                <NavLink to="/features" className="sub-menu">
                  Feature
                </NavLink>
              </li>
              <li>
                <NavLink to="/our-teams" className="sub-menu">
                  Our Team
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/our-partners" className="sub-menu">
                  Our Partner
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink to="/success-story" className="sub-menu">
                  Success Story
                </NavLink>
              </li> */}
              <li>
                <NavLink to="/advisory-board" className="sub-menu">
                  Advisory Board
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact-us" className="sub-menu">
                  Contact Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact-us-partner" className="sub-menu">
                  Contact Us (Partner)
                </NavLink>
              </li>
            </ul>
          )}
          <p className="title"></p>

          <p className="title"></p>

          {/* <li>
            <NavLink
              to="/report"
              style={{ textDecoration: "none" }}
              className="main-menu">
              <SummarizeOutlinedIcon className="icon" />
              <span>Report</span>
            </NavLink>
          </li> */}

          <p className="title"></p>
          <li
            onClick={() => {
              localStorage.setItem("navOpen4", !drawer);
              setDrawer(!drawer);
            }}
          >
            <AttachMoneyOutlinedIcon className="icon" />
            <span>Advisor</span>
            <div className="dropdown-icon">
              {drawer ? <ExpandMoreOutlinedIcon /> : <ExpandLessOutlinedIcon />}
            </div>
          </li>
          {!drawer && (
            <ul className="sub-list">
              <li>
                <NavLink
                  to="/report"
                  // to=""
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                // className="sub-menu submenu-disable"
                >
                  Investment Report
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/commission"
                  style={{ textDecoration: "none" }}
                  className="sub-menu"
                >
                  Commision
                </NavLink>
              </li> */}
            </ul>
          )}

          <li>
            <NavLink
              to="/profile"
              style={{ textDecoration: "none" }}
              className="main-menu"
            >
              <AccountCircleOutlinedIcon className="icon" />
              <span>Profile</span>
            </NavLink>
          </li>

          <Link
            to="/login"
            onClick={logoutHandler}
            style={{ textDecoration: "none" }}
          >
            <li>
              <ExitToAppIcon className="icon" />
              <span>Logout</span>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
